// eslint-disable-next-line max-classes-per-file
import { Metamodel } from '../base/model';
import { ModelConstants } from '../model-constants';
import { IViolation } from '../base/annotation';
import { ProvisioningState, ConnectionState, PrivateEndpointType } from './managedprivateenpoint-types';
import { ManagedVirtualNetwork } from '../managedvirtualnetwork/managedVirtualNetwork';
import { ChildResourceNamed } from '../base/child-resource-named';
import { ActionConstants } from '../../constants/action-constants';
import { shellStringResources } from '../../Resources/ShellStringResources';

@Metamodel.model({
    name: 'connection state'
})
export class ManagedPrivateEndpointProperties {
    @Metamodel.attribute({
        display: shellStringResources.PrivateEndpointStatus
    })
    public status: ConnectionState;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Description
    })
    public description: string;
}

@Metamodel.model({
    name: ModelConstants.managedPrivateEndpoint,
    display: ['Managed Private Connections'],
    reusable: true,
    referable: true,
    validator: ManagedPrivateEndpoint.validate,
    accessPublishConstraint: {
        writeResource: {
            action: ActionConstants.managedPrivateEndpointsWrite
        },
        deleteResource: {
            action: ActionConstants.managedPrivateEndpointsDelete
        }
    }
})
export class ManagedPrivateEndpoint extends ChildResourceNamed {
    @Metamodel.attribute({
        display: shellStringResources.Name
    })
    public name: string;

    @Metamodel.attribute({
        display: shellStringResources.Error
    })
    public error: string;

    @Metamodel.attribute({
        display: shellStringResources.ProvisioningState
    })
    public provisioningState: ProvisioningState;

    @Metamodel.attribute({
        display: shellStringResources.PrivateEndpointPrivateIP
    })
    public ipAddress: string;

    @Metamodel.attribute({
        display: shellStringResources.PrivateEndpointResourceId
    })
    public resourceId: string;

    @Metamodel.attribute({
        display: shellStringResources.PrivateLinkResourceId
    })
    public privateLinkResourceId: string;

    @Metamodel.attribute({
        display: shellStringResources.PrivateLinkReserved
    })
    public isReserved: boolean;

    @Metamodel.attribute({
        display: shellStringResources.PrivateEndpointGroupID
    })
    public groupId: PrivateEndpointType;

    @Metamodel.attribute({
        display: 'FQDNs'
    })
    public fqdns: string[];

    @Metamodel.attribute({
        display: shellStringResources.PrivateEndpointConnectionState
    })
    public connectionState: ManagedPrivateEndpointProperties;

    @Metamodel.attribute({
        type: ManagedVirtualNetwork.MODEL,
        reference: true,
        constraint: {
            unique: true
        }
    })
    public managedVirtualNetwork: ManagedVirtualNetwork;

    public violations: string[];

    public resourceName: string;

    public get parentResource(): ManagedVirtualNetwork {
        return this.managedVirtualNetwork;
    }

    public get resourceType(): string {
        const resourceId = (this.privateLinkResourceId && this.privateLinkResourceId.trim()) || '';
        if (resourceId) {
            // starting index depends on whether the resource ID starts with a '/'
            const namepaceSplitIndex = resourceId[0] === '/' ? 6 : 5;
            const parts = resourceId.split('/');
            return `${parts[namepaceSplitIndex]}/${parts[namepaceSplitIndex + 1]}`;
        }
        return '';
    }

    constructor(name?: string, description?: string) {
        super(name, description);
        this.connectionState = new ManagedPrivateEndpointProperties();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private static validate(owner: any): IViolation[] | undefined {
        const named = (owner && owner.named) as ManagedPrivateEndpoint;

        if (named && named.violations) {
            return named.violations.map((violation) => ({
                context: owner,
                message: () => violation
            }));
        }

        return undefined;
    }
}
